import React, { useState, useEffect } from "react";
import completed from "../../../../../images/completed.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import {
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ButtonDropdown,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import addAccessTokenToUrl from "../../../../Utils/Axios/addTokenToUrl";
import { useMobileStatus } from "../../../../Utils/useMobileStatus";
import useWindowSize from '../../../../Utils/useWindowSize';

export default function FilterOption(props) {
  const filterData = JSON.parse(localStorage.getItem("filterData"));
  const [OrientationOptions, setOrientationOptions] = useState([]);
  const [assessmentsArray, setAssessmentData] = useState([]);
  const [availableReports, setAvailableReports] = useState([]);
  const [isToastVisible, setIsToastVisible] = useState(false);
  const [orientationDropdownOpen, setOrientationDropdownOpen] = useState(false);
  const [selectedOrientation, setSelectedOrientation] = useState([]);
  const [isFirstDropdownOpen, setIsFirstDropdownOpen] = useState(false);
  const [isOrientationDropdownOpen, setIsOrientationDropdownOpen] = useState(false);
  const [isReportTypeDropdownOpen, setIsReportTypeDropdownOpen] = useState(false);

  const { width } = useWindowSize();





  useEffect(() => {
    getAssessmentList()
      .then((response) => {
        const newData = response.data.data.map((item) => ({
          id: item.id,
          created: new Date(item.created).toISOString().split("T")[0],
        }));
        setAssessmentData(newData);
      })
      .catch((error) => {
        console.error("Error fetching assessment list:", error);
      });
  }, []);

  function getAssessmentList() {
    const instrumentId = filterData.formData.dropdown2 === "LOI Self" ? 9 : 2;
    const startSplit = filterData.formData.dateRangeValue.startDate.split("/");
    const startDate = `${startSplit[2]}-${startSplit[1]}-${startSplit[0]}`;
    const endSplit = filterData.formData.dateRangeValue.endDate.split("/");
    const endDate = `${endSplit[2]}-${endSplit[1]}-${endSplit[0]}`;
    const participantId = localStorage.getItem("participant_id");
    const requestBody = {
      instrument_id: instrumentId,
      start_date: startDate,
      end_date: endDate,
      user: participantId,
    };

    return axios.post(
      addAccessTokenToUrl("/assessments/date_range/assessments/list"),
      requestBody
    );
  }

  const ReportTypeOptions = [
    { id: 1, name: "360-Degree Feedback" },
    { id: 2, name: "Collaborative Style" },
    { id: 3, name: "Execution Style" },
    { id: 4, name: "Leadership Style" },
    { id: 5, name: "Overall Social Style" },
    { id: 6, name: "Customer-Management Style" },
    { id: 7, name: "Coaching Style" },
    { id: 8, name: "Self-Development Style" },
    { id: 9, name: "Social Style - Children" },
    { id: 10, name: "Social Style - Friends" },
    { id: 11, name: "Social Style - Parents" },
    { id: 12, name: "Social Style - Business Partner" },
    { id: 13, name: "Social Style - Siblings & Cousins" },
    { id: 14, name: "Social Style - Spouse" },
    { id: 15, name: "Vendor-Management Style" },
    { id: 16, name: "Value" },
    { id: 17, name: "group test" },
  ];

  const instrumentType = filterData.formData.dropdown2;
  const storedIds = localStorage.getItem("assessmentIds");







  const [assessmentIdList, setAssessmentIdList] = useState([]);





  const [relation, setRelation] = useState([]);
  const [relationId, setRelationId] = useState([]);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);



  const initialReportTypeNames = [
    "360-Degree Feedback",
    "Collaborative Style",
    "Execution Style",
    "Leadership Style",
    "Overall Social Style",
    "Customer-Management Style",
    "Coaching Style",
  ];

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  useEffect(() => {
    const rawFilterData = localStorage.getItem("filterData");
    const filterData = rawFilterData ? JSON.parse(rawFilterData) : {};

    const storedIds = localStorage.getItem("assessmentIds");

    const storedOrientation =
      filterData.formData && filterData.formData.orientation && Array.isArray(filterData.formData.orientation)
        ? filterData.formData.orientation
        : OrientationOptions;

    const storedRelation = filterData.formData && filterData.formData.relation ? filterData.formData.relation : "";



    const assessmentIdListArray = storedIds ? storedIds.split(",").map(Number) : [];



    setAssessmentIdList(assessmentIdListArray);
    setSelectedOrientation(storedOrientation);
    setRelation(storedRelation);
  }, [OrientationOptions]);

  useEffect(() => {
    localStorage.setItem("assessmentIds", assessmentIdList);
    if (props.setReload) {
      props.setReload((prevReload) => !prevReload);
    }
  }, [assessmentIdList]);

  useEffect(() => {
    const rawFilterData = localStorage.getItem("filterData");
    const filterData = rawFilterData ? JSON.parse(rawFilterData) : {};

    const updatedFilterData = {
      ...filterData.formData,
      orientation: selectedOrientation,
      relation: relation,
      relationId: relationId,
    };

    localStorage.setItem(
      "filterData",
      JSON.stringify({ formData: updatedFilterData })
    );
    if (props.setReload) {
      props.setReload((prevReload) => !prevReload);
    }
  }, [selectedOrientation, relation, relationId]);



  const [lastClickedAssessmentId, setLastClickedAssessmentId] = useState(null);


  const handleClick = (index) => {
    const assessmentId = assessmentsArray[index].id;
    const isIdRepeated = assessmentIdList.includes(assessmentId);
    const selectedCount = assessmentIdList.length;
    const isOnlySelectedCard = selectedCount === 1 && isIdRepeated;
    const selectedReportsCount = relation.length;



    if ((selectedReportsCount >= 3 || selectedReportsCount === 2) && !isIdRepeated && selectedCount >= 1) {

      if (!isToastVisible) {
        toast["info"](`You cannot select more than 1 date when 2 or more report styles are selected.`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
          onClose: () => setIsToastVisible(false),
        });
        setIsToastVisible(true);
      }
      return;
    }

    if (selectedCount >= 3 && !isIdRepeated) {
      if (!isToastVisible) {
        toast["info"](`You can only select up to 3 cards.`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
          onClose: () => setIsToastVisible(false),
        });
        setIsToastVisible(true);
      }
      return;
    } else if (isOnlySelectedCard) {
      if (!isToastVisible && lastClickedAssessmentId !== assessmentId) {
        toast["info"](`At least one Assessment should be selected.`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
          onClose: () => {
            setIsToastVisible(false);
            setLastClickedAssessmentId(null);
          },
        });
        setIsToastVisible(true);
        setLastClickedAssessmentId(assessmentId);
      }
      return;
    }

    setAssessmentIdList((prevList) => {
      const arrayIds =
        typeof prevList === "string" ? prevList.split(",").map(Number) : prevList;

      if (isIdRepeated) {
        return arrayIds.filter((id) => id !== assessmentId);
      } else {
        return [...arrayIds, assessmentId];
      }
    });
  };

  const handleReportClick = (name, id) => {
    const assessmentIdsArray = assessmentIdList.length > 0 ? assessmentIdList : [];
    const isReportSelected = relation.includes(name);
    const selectedReportsCount = relation.length;

    if (assessmentIdsArray.length === 1) {
      if (selectedReportsCount >= 3 && !isReportSelected) {
        if (!isToastVisible) {
          toast["info"]("You cannot select more than 3 report styles.", {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 2000,
            onClose: () => setIsToastVisible(false),
          });
          setIsToastVisible(true);
        }
        return;
      }
    } else if (assessmentIdsArray.length > 1) {
      if (selectedReportsCount >= 1 && !isReportSelected) {
        if (!isToastVisible) {
          toast["info"]("You cannot select more than 1 report style when multiple assessments are selected.", {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 2000,
            onClose: () => setIsToastVisible(false),
          });
          setIsToastVisible(true);
        }
        return;
      }
    }

    if (selectedReportsCount === 1 && isReportSelected) {
      if (!isToastVisible) {
        toast["info"]("At least one report type should be selected.", {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
          onClose: () => setIsToastVisible(false),
        });
        setIsToastVisible(true);
      }
      return;
    }

    setRelation((prevRelation) => {
      const isSelected = prevRelation.includes(name);
      if (isSelected) {
        return prevRelation.filter((item) => item !== name);
      } else {
        return [...prevRelation, name];
      }
    });

    setRelationId((prevRelationId) => {
      const relationIdArray = Array.isArray(prevRelationId) ? prevRelationId : [];
      const isSelected = relationIdArray.includes(id);
      if (isSelected) {
        return relationIdArray.filter((item) => item !== id);
      } else {
        return [...relationIdArray, id];
      }
    });

    setIsToastVisible(false);
  };

  useEffect(() => {
    getOrientationList()
      .then((response) => {
        const options = response.data.response.map(
          (item) => item.orientation__orientation_name
        );
        setOrientationOptions(options);
      })
      .catch((error) => {
        console.error("Error fetching orientation list:", error);
      });
  }, []);

  function getOrientationList() {
    const data = {
      instrument_id: 9,
    };
    return axios.post(
      addAccessTokenToUrl("/masters/instrument/orientation/list/"),
      data
    );
  }

  function getRelationGroupName() {
    const user = localStorage.getItem("participant_id");
    const userAssessment = storedIds ? storedIds.split(",").filter(id => id.trim() !== "").map(Number) : [];
  
    // Only proceed if there are valid assessment IDs
    if (userAssessment.length === 0) {
      return Promise.resolve({ data: { available_reports: [] } });
    }
  
    const data = {
      user_assessment: userAssessment,
      user: user,
      screen_type: "assessment_summary",
    };
    return axios.post(
      addAccessTokenToUrl("/assessments/comparison/relation/group/list"),
      data
    );
  }

  useEffect(() => {
    getRelationGroupName()
      .then((response) => {
        setAvailableReports(response.data.available_reports);
      })
      .catch((error) => {
        console.error("Error fetching relation group name:", error);
        setAvailableReports([]);
      });
  }, [storedIds]);
  

  useEffect(() => {

    const feedbackReport = availableReports.find(
      (report) => report.relation_group_name === "360-Degree Feedback"
    );

    if (feedbackReport) {

      setRelation([feedbackReport.relation_group_name]);
      setRelationId([feedbackReport.relation_group_id]);
    } else {

      setRelation([]);
      setRelationId([]);
    }
  }, [availableReports]);

  const isMobile = useMobileStatus();

  const toggleOrientationDropdown = () => {
    setIsOrientationDropdownOpen(!isOrientationDropdownOpen);
    setIsReportTypeDropdownOpen(false);
  };

  const toggleReportTypeDropdown = () => {
    setIsReportTypeDropdownOpen(!isReportTypeDropdownOpen);
    setIsOrientationDropdownOpen(false);
  };




  const handleOrientationCheckboxChange = (option) => {
    const selectedIndex = selectedOrientation.indexOf(option);
    let newSelectedOrientation = [];

    if (selectedIndex === -1) {
      newSelectedOrientation = [...selectedOrientation, option];
    } else {
      if (selectedOrientation.length === 1) {
        if (!isToastVisible) {
          toast["info"](`At least one Orientation should be selected.`, {
            position: toast.POSITION.BOTTOM_LEFT,
            autoClose: 2000,
            onClose: () => {
              setIsToastVisible(false);
            },
          });
          setIsToastVisible(true);
        }

        return;
      }
      newSelectedOrientation = selectedOrientation.filter((item) => item !== option);
    }

    setSelectedOrientation(newSelectedOrientation);

  };

  const handleOrientationClick = (orientation, index) => {
    if (
      selectedOrientation.length === 1 &&
      selectedOrientation.includes(orientation)
    ) {
      if (!isToastVisible) {
        toast["info"](`At least one Orientation should be selected.`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 2000,
          onClose: () => setIsToastVisible(false),
        });
        setIsToastVisible(true);
      }
      return;
    }

    setSelectedOrientation((prevSelectedOrientation) => {
      const isSelected = prevSelectedOrientation.includes(orientation);
      if (isSelected) {
        return prevSelectedOrientation.filter((item) => item !== orientation);
      } else {
        return [...prevSelectedOrientation, orientation];
      }
    });

    setIsToastVisible(false);
  };

  return (
    <div>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {assessmentsArray.map((assessment, index) => (
          <div
            key={index}
            style={{
              border: assessmentIdList.includes(assessment.id)
                ? "1px solid transparent"
                : "1px solid #D4DEF0",
              width: "fit-content",
              padding: "10px 20px",
              borderRadius: "5px",
              backgroundColor: assessmentIdList.includes(assessment.id)
                ? "#30c534"
                : "transparent",
              color: assessmentIdList.includes(assessment.id)
                ? "white"
                : "#2C3E50",
              cursor: "pointer",
              fontSize: "18px",
              fontWeight: 500,
            }}
            onClick={() => handleClick(index)}
          >
            {assessment.created}
          </div>
        ))}
      </div>
      <hr
        style={{
          height: "2px",
          border: "none",
          borderBottom: "2px dashed #D4DEF0",
        }}
      />
      {width > 500 ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          {OrientationOptions.map((orientation, index) => (
            <div
              key={index}
              style={{
                border: selectedOrientation.includes(orientation)
                  ? "1px solid #35BC39"
                  : "1px solid #D4DEF0",
                width: "fit-content",
                padding: "10px 20px",
                borderRadius: "5px",
                display: "flex",
                gap: "10px",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: 600,
                color: "#2C3E50",
                background: selectedOrientation.includes(orientation)
                  ? "#F0FEF1"
                  : "white",
              }}
              onClick={() => handleOrientationClick(orientation, index)}
            >
              {orientation}
              {selectedOrientation.includes(orientation) ? (
                <div
                  style={{
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                  }}
                >
                  <img src={completed} alt="Completed Image" />
                </div>
              ) : (
                <div
                  style={{
                    color: "white",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    background: "#f6f6f6",
                    border: "1px solid grey",
                  }}
                ></div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <FormGroup>
          <Label for="dropdown2" style={{ color: "grey", fontSize: '15px' }}>
            Select Orientation
          </Label>
          <ButtonDropdown
            style={{
              width: "100%",
              maxWidth: isMobile ? "370px" : "400px",
              height: "50px",
              background: "white",
            }}
            isOpen={isOrientationDropdownOpen}
            toggle={toggleOrientationDropdown}

          >
            <DropdownToggle
              onClick={toggleOrientationDropdown}
              className="d-flex justify-content-between align-items-center"
              style={{
                background: "white",
                color: "black",
                paddingLeft: "10px",
                paddingRight: "10px",
                border: "1px solid #dbdbdb",
                width: "100%",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {selectedOrientation.length === OrientationOptions.length ? (
                "All"
              ) : selectedOrientation.length === 0 ? (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={completed} alt="#" style={{ marginRight: "5px" }} /> Select Orientation
                </div>
              ) : (
                <span>{selectedOrientation.join(", ")}</span>
              )}
              <i
                className={`fa fa-chevron-${isOrientationDropdownOpen ? "up" : "down"}`}
                aria-hidden="true"
                style={{ transition: "transform 0.3s" }}
              />
            </DropdownToggle>

            <DropdownMenu
              style={{ width: "100%", maxWidth: isMobile ? "370px" : "400px", zIndex: 10 }}
            >
              {OrientationOptions.map((option, index) => (
                <div key={index}>
                  <DropdownItem
                    style={{
                      width: "100%",
                      height: "30px",
                      background: "white",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "40px",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Label check>
                      <Input
                        type="checkbox"
                        value={option}
                        checked={selectedOrientation.includes(option)}
                        onChange={(e) => {
                          e.stopPropagation();
                          handleOrientationCheckboxChange(option);
                        }}
                        onClick={(e) => e.stopPropagation()}
                      />
                      {option}
                    </Label>
                  </DropdownItem>
                  {index < OrientationOptions.length - 1 && <hr />}
                </div>
              ))}
            </DropdownMenu>
          </ButtonDropdown>
        </FormGroup>
      )}
      {instrumentType === "LOI Self" ? null : (
        <div>
          <hr
            style={{
              height: "2px",
              border: "none",
              borderBottom: "2px dashed #D4DEF0",
            }}
          />
          {isMobile ? (

            <FormGroup>
              <Label for="dropdown2" style={{ color: "grey", fontSize: '15px' }}>
                Select Report Type
              </Label>
              <ButtonDropdown
                style={{
                  width: "100%",
                  maxWidth: isMobile ? "370px" : "400px",
                  height: "50px",
                  background: "white",
                }}
                isOpen={isReportTypeDropdownOpen}
                toggle={toggleReportTypeDropdown}

              >
                <DropdownToggle
                  onClick={toggleAccordion}
                  className="d-flex justify-content-between align-items-center"
                  style={{
                    background: "white",
                    color: "black",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    border: "1px solid #dbdbdb",
                    width: "100%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                  }}
                >
                  {relation.length === 0 ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <i className="fa fa-list" style={{ marginRight: "5px" }} />
                      Select Report Type
                    </div>
                  ) : (
                    <span>{relation.join(", ")}</span>
                  )}
                  <i
                    className={`fa fa-chevron-${isAccordionOpen ? "up" : "down"}`}
                    aria-hidden="true"
                    style={{ transition: "transform 0.3s" }}
                  />
                </DropdownToggle>
                <DropdownMenu
                  style={{
                    width: "100%",
                    maxWidth: isMobile ? "370px" : "400px",
                    maxHeight: "200px",
                    overflowY: "auto",
                    zIndex: 10
                  }}
                >
                  {ReportTypeOptions.filter((report) => {
                    const isAvailable = availableReports.some(
                      (availReport) => availReport.relation_group_name === report.name
                    );
                    return isAvailable;
                  }).map((report, index, arr) => {
                    const selectedRelation = availableReports.find(
                      (availReport) => availReport.relation_group_name === report.name
                    );
                    const relationGroupId = selectedRelation ? selectedRelation.relation_group_id : "";
                    const isSelected = relation.includes(report.name);

                    return (
                      <React.Fragment key={index}>
                        <DropdownItem
                          style={{
                            width: "100%",
                            height: "30px",
                            background: "white",
                            display: "flex",
                            alignItems: "center",
                            paddingLeft: "40px",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Label check>
                            <Input
                              type="checkbox"
                              checked={isSelected}
                              onChange={(e) => {
                                e.stopPropagation();
                                handleReportClick(report.name, relationGroupId);
                              }}
                              onClick={(e) => e.stopPropagation()}
                            />
                            {report.name}
                          </Label>
                        </DropdownItem>
                        {index !== arr.length - 1 && <hr />}
                      </React.Fragment>
                    );
                  })}
                </DropdownMenu>
              </ButtonDropdown>
            </FormGroup>

          ) : (
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start', width: '100%' }}>
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", flex: 1, maxWidth: 'calc(100% - 120px)' }}>
                {ReportTypeOptions.filter(report => isAccordionOpen || initialReportTypeNames.includes(report.name)).map((report, index) => {
                  const isAvailable = availableReports.some(availReport => availReport.relation_group_name === report.name);
                  const isSelected = relation.includes(report.name);
                  const selectedRelation = availableReports.find(
                    (relation) => relation.relation_group_name === report.name
                  );
                  const relationGroupId = selectedRelation ? selectedRelation.relation_group_id : "";

                  return (
                    <div
                      key={index}
                      style={{
                        border: "1px solid #ccc",
                        border: isAvailable ? (isSelected ? "1px solid #F16609" : "1px solid #D4DEF0") : "1px solid #ccc",
                        width: "fit-content",
                        padding: "10px 20px",
                        borderRadius: "5px",
                        backgroundColor: isSelected ? "#FEF0E6" : "transparent",
                        color: isSelected ? "#F16609" : "#2C3E50",
                        cursor: isAvailable ? "pointer" : 'not-allowed',
                        fontSize: "14px",
                        fontWeight: 600,
                        opacity: isAvailable ? 1 : 0.5,
                      }}
                      onClick={() => isAvailable && handleReportClick(report.name, relationGroupId)}
                    >
                      {report.name}
                    </div>
                  );
                })}
              </div>
              <div style={{ minWidth: '100px', textAlign: 'right', padding: '10px' }}>
                <button onClick={toggleAccordion} style={{ border: 'none', background: 'none', fontSize: '14px', color: 'black' }}>
                  {isAccordionOpen ? 'Show Less ' : 'Show More '}
                  <i className={`fa ${isAccordionOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`} style={{ color: 'black' }} />
                </button>
              </div>
            </div>
          )}
        </div>
      )}


      <hr
        style={{
          height: "2px",
          border: "none",
          borderBottom: "2px dashed #D4DEF0",
        }}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/new/Components/Reports/Assessment-Reports/FilterOption/index.jsx